import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const DownloadLink = ({ to }) => (
  <a
    href={to}
    target="_parent"
    download
    className="btn btn-sm gap-2 bg-white shadow-sm hover:shadow rounded-md border border-gray-200 text-gray-600"
    rel="noreferrer"
  >
    <ArrowDownTrayIcon className="w-4 h-4" />
    Download
  </a>
);

export default DownloadLink;

DownloadLink.propTypes = {
  to: PropTypes.string,
};
